import type {ReactElement} from 'react';
import {Button, IconPlacement, Size, Type} from '@Components/button';
import type {FixThisButtonProps} from './fix-this-button.types';
import {FIX_THIS_ICON} from './fix-this-button.types';

export function FixThisButton({onClick, isLoading, disabled, variant = 'secondary', isFullWidth = false, isCompact = false, customClasses}: FixThisButtonProps): ReactElement {
  return (
    <Button
      type={variant === 'primary' ? Type.PRIMARY : Type.SECONDARY}
      size={Size.SMALL}
      icon={FIX_THIS_ICON}
      iconPlacement={IconPlacement.LEFT}
      text={window.i18next.t(isCompact ? 'pmwjs_social_fix' : 'pmwjs_social_fix_this')}
      onClick={onClick}
      isLoading={isLoading}
      disabled={disabled}
      isFullWidth={isFullWidth}
      customClasses={customClasses}
    />
  );
}
